import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';
import { scrollProgress, lineOffset } from '@theme/eme-scroll-text-core';

class EmeScrollText extends Component {
  #observer = null;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.#apply(1);
      return;
    }
    this.#observer = new IntersectionObserver(this.#handleIntersect);
    this.#observer.observe(this);
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#observer = null;
    this.#stop();
  }

  #apply(progress) {
    for (const line of this.refs.lines ?? []) {
      line.style.transform = `translateX(${lineOffset(progress, line.dataset.direction ?? 'left')})`;
    }
  }

  #update() {
    const { top } = this.getBoundingClientRect();
    this.#apply(scrollProgress({ top, height: this.offsetHeight, viewport: window.innerHeight }));
  }

  #tick = () => {
    this.#update();
    this.#frame = requestAnimationFrame(this.#tick);
  };

  #start() {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(this.#tick);
  }

  #stop() {
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #handleIntersect = (entries) => {
    const visible = entries.at(-1)?.isIntersecting;
    if (visible) {
      this.#start();
      return;
    }
    this.#stop();
    this.#update();
  };
}

if (!customElements.get('eme-scroll-text')) customElements.define('eme-scroll-text', EmeScrollText);
